import React, { useState, useEffect } from "react";
import "./Profile.scss";
import { connect } from "react-redux";
import Axios from "../../../utils/axios";
import blankAvatarImage from "../../../images/blank-profile-picture-973460_1280.webp";
import { Link } from "react-router-dom";

function ViewProfile({ profileData, id }) {
  const [userProfile, setUserProfile] = useState({});
  const [isLiked, setIsLiked] = useState(false);
  useEffect(() => {
    Axios.get(`/api/accounts/v1/user/profile/${id}`)
      .then(response => {
        const profileData = response.data;
        setUserProfile(profileData);
        console.log(profileData);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const handleFollowButton = event => {
    setIsLiked(!isLiked);
    if (!isLiked) {
      const formData = new FormData();
      formData.append("follow_to", id);
      formData.append("follow_by", null);
      Axios.post("/api/accounts/v1/user/follow/detail", formData)
        .then(response => {
          const profileData = response.data;
          setUserProfile(profileData);
          console.log(profileData);
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
  return (
    <div className="profile">
      <div className="profile-image-section">
        <div className="card">
          <div className="card-body p-0 rounded">
            <div className="cover rounded" />
            <div className="user-info">
              <img
                src={userProfile?.user?.profile_img || blankAvatarImage}
                alt=""
              />
              <h4 className="font-weight-bold pt-2">
                {userProfile?.user?.first_name || " "}{" "}
                {userProfile?.user?.last_name || ""}
              </h4>
              <p className="text-muted p-0">{userProfile?.user?.username}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="profile-about-section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header about-header font-weight-bold">
                About
              </div>
              <div className="card-body about-body">
                <p>
                  Semester: {userProfile?.user?.profile?.education?.semester}{" "}
                  Sem
                </p>
                <p>
                  Faculty: {userProfile?.user?.profile?.education?.faculty_name}
                </p>
                <p>
                  University:{" "}
                  {userProfile?.user?.profile?.education?.university_name}
                </p>
                <hr />
                <div className="row follow">
                  <div className="col-md-6 followers">
                    <p>{userProfile?.followers}</p>
                    <p>Followers</p>
                  </div>
                  <div className="col-md-6 following">
                    <p>{userProfile?.following}</p>
                    <p>Following</p>
                  </div>
                </div>
                <hr />
                <div className="d-block d-sm-flex align-items-center justify-content-between">
                  <button
                    type="submit"
                    onClick={handleFollowButton}
                    className="post-button">
                    {!isLiked ? "Follow" : "Followed"}
                  </button>
                  <div className="px-3">
                    <Link to="/change/password" className="px-3">
                      Change password
                    </Link>
                    <Link to="/edit-profile" className=" px-2">
                      Edit Profile
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => {
  return {
    profileData: state.profile,
  };
};

export default connect(mapStateToProps)(ViewProfile);
